import api from '../api';
import { Pos, Terminal } from './types';

const createTerminal = async (terminal: Pos) => {
  try {
    const response = await api.post<Pos>('/terminals', terminal);
    return response;
  } catch (error) {
    console.error('Error in createTerminal:', error);
    throw error;
  }
};

const pairTerminal = async (terminalId: string) => {
  try {
    const response = await api.post(
      `/payments/pavo/cloud/terminals/${terminalId}/pair`,
    );
    return response;
  } catch (error) {
    console.error('Error in pairTerminal:', error);
    throw error;
  }
};

const getTerminals = async (): Promise<any> => {
  try {
    const response = await api.get('/terminals');
    return response.data;
  } catch (error) {
    console.error('Error in getTerminals:', error);
    throw error;
  }
};

const deleteTerminal = async (terminalId: string) => {
  try {
    const response = await api.delete(`/terminals/${terminalId}`);
    return response;
  } catch (error) {
    console.error('Error in deleteTerminal:', error);
    throw error;
  }
};

const deleteSettings = async (settingsId: string) => {
  try {
    const response = await api.delete(`/payments/settings/${settingsId}`);
    return response;
  } catch (error) {
    console.error('Error in deleteTerminal:', error);
    throw error;
  }
};

const updateTerminal = async (terminalId: string, terminal: Pos) => {
  try {
    console.log(
      `Sending PATCH request to /terminals/${terminalId} with data:`,
      terminal,
    );
    const response = await api.patch<Pos>(`/terminals/${terminalId}`, terminal);
    return response;
  } catch (error) {
    console.error('Error in updateTerminal:', error);
    throw error;
  }
};
const createPaymentGateway = async (data: any) => {
  try {
    const response = await api.post('/payments/settings', data);
    return response;
  } catch (error) {
    console.error('Error in createPaymentGateway:', error);
    throw error;
  }
};

const getPaymentSettings = async () => {
  try {
    const response = await api.get('/payments/settings');

    return response.data;
  } catch (error) {
    console.error('Error in getPaymentSettings:', error);
    throw error;
  }
};

export default {
  createTerminal,
  getTerminals,
  deleteTerminal,
  updateTerminal,
  pairTerminal,
  createPaymentGateway,
  getPaymentSettings,
  deleteSettings,
};
